import {Chip, styled} from "@mui/material";

const FileTag = styled(Chip)(({theme}) => ({
    backgroundColor: theme.palette.primary.light,
    borderRadius: 4,
}));
export default FileTag;